// extracted by mini-css-extract-plugin
export default {"root":"BwC1LeWNbh0t2oF804Os","content":"nxvDvjmA4xkXMMdokt7O","placeHolderShimmer":"u2XXDo7NXtQq5iGhRSDF"};